export const MAP_THEMES = {
    SATELLITE: 'satellite',
    MONOCHROME: 'monochrome',
  };
  export const MAP_STYLE_URLS = {
    [MAP_THEMES.SATELLITE]: 'mapbox://styles/asiamobiliti/cmmiuekib00e701raeahf215b',
    [MAP_THEMES.MONOCHROME]: 'mapbox://styles/asiamobiliti/ckb1yq6080opd1inb3lkdmbii',
  };
  export const defaultMapTheme = MAP_THEMES.MONOCHROME;
  export const getMapStyle = (theme = defaultMapTheme) => MAP_STYLE_URLS[theme] || MAP_STYLE_URLS[defaultMapTheme];
